import { REGION_IDS } from '@/config/constants'

export default function isRegionUK(regionId) {
  return parseInt(regionId, 10) === REGION_IDS.UK
}
